// extracted by mini-css-extract-plugin
module.exports = {"center":"SingleBlog_center__3QL13","avatar":"SingleBlog_avatar__3MBuQ","content":"SingleBlog_content__NprAn"};